import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseRemove = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.44194 4.55806C5.19786 4.31398 4.80213 4.31398 4.55806 4.55806C4.31398 4.80213 4.31398 5.19786 4.55806 5.44194L9.11608 10L4.55806 14.5581C4.31398 14.8022 4.31398 15.1978 4.55806 15.4419C4.80213 15.686 5.19786 15.686 5.44194 15.4419L10 10.8839L14.5581 15.4419C14.8022 15.686 15.1978 15.686 15.4419 15.4419C15.686 15.1978 15.686 14.8022 15.4419 14.5581L10.8839 10L15.4419 5.44194C15.686 5.19786 15.686 4.80213 15.4419 4.55806C15.1978 4.31398 14.8022 4.31398 14.5581 4.55806L10 9.11608L5.44194 4.55806Z" })
});
export default SvgCloseRemove;
